import { AloftPrice, AloftPriceJSON, orUndefined } from '@aloft/toolkit-shared';

/** @deprecated - Use orUndefined(AloftPrice.schema.parse)(priceJSON) directly instead */
export const priceJSONToPrice = (priceJSON?: AloftPriceJSON): AloftPrice | undefined => {
  const price = orUndefined(AloftPrice.schema.safeParse)(priceJSON);
  if (!price || !price.success) return undefined;
  return price.data;
};
